import { REMOVE_TOKENS_START, STORE_TOKENS_START, SET_SCOPE } from './actionTypes.js';

var initialState = {
  access_token: {},
  refresh_token: {},
  scope: 'user'
};
var reducer = (function (state, action) {
  var _Object$assign, _Object$assign2, _Object$assign3, _Object$assign4;
  if (state === void 0) {
    state = initialState;
  }
  switch (action.type) {
    case SET_SCOPE:
      return Object.assign({}, state, {
        scope: action.scope
      });
    case STORE_TOKENS_START:
      return Object.assign({}, state, {
        access_token: Object.assign({}, state.access_token, (_Object$assign = {}, _Object$assign[action.tokenKey] = action.access_token || state.access_token[action.tokenKey] || null, _Object$assign)),
        refresh_token: Object.assign({}, state.refresh_token, (_Object$assign2 = {}, _Object$assign2[action.tokenKey] = action.refresh_token || state.refresh_token[action.tokenKey] || null, _Object$assign2))
      });
    case REMOVE_TOKENS_START:
      return Object.assign({}, state, {
        access_token: Object.assign({}, state.access_token, (_Object$assign3 = {}, _Object$assign3[action.tokenKey] = null, _Object$assign3)),
        refresh_token: Object.assign({}, state.access_token, (_Object$assign4 = {}, _Object$assign4[action.tokenKey] = null, _Object$assign4))
      });
    default:
      return state;
  }
});

export { reducer as default };
//# sourceMappingURL=reducer.js.map
